import { render, staticRenderFns } from "./ItinerarySection.vue?vue&type=template&id=734e65a6&"
import script from "./ItinerarySection.vue?vue&type=script&lang=js&"
export * from "./ItinerarySection.vue?vue&type=script&lang=js&"
import style0 from "./ItinerarySection.vue?vue&type=style&index=0&id=734e65a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports